import React, { useState } from 'react';

/**
 * Baner "wrzucono plik nie tego typu".
 *
 * I faktura, i cennik to pliki .xml - pracownicy myla sloty. Backend rozpoznaje
 * typ po ZAWARTOSCI i zwraca wykryto/oczekiwano/sugerowany_krok. Tutaj pokazujemy
 * JEDEN czytelny komunikat i JEDEN przycisk prowadzacy dalej; diagnostyka techniczna
 * jest zwinieta pod "Szczegoly".
 *
 * wykryto: 'cennik' | 'faktura' | 'paragon' | 'nieznany' | 'uszkodzony'
 */
const WrongFileNotice = ({
  wykryto, oczekiwano, filename, komunikat, diagnostyka,
  sugerowanyKrok, onUzyjWInnymKroku, onWybierzInny,
  moznaWymusic = false, onWymus
}) => {
  const [pokazSzczegoly, setPokazSzczegoly] = useState(false);

  // Pomylony typ (cennik <-> faktura) to ostrzezenie; plik obcy/uszkodzony to blad
  const pomylonyTyp = wykryto === 'cennik' || wykryto === 'faktura' || wykryto === 'paragon';
  const tlo = pomylonyTyp ? 'var(--warning-light)' : 'var(--danger-light)';
  const ramka = pomylonyTyp ? 'var(--warning)' : 'var(--danger)';

  const nazwyTypow = {
    cennik: 'CENNIK',
    faktura: 'FAKTURĘ',
    paragon: 'PARAGON',
    nieznany: 'nierozpoznany plik',
    uszkodzony: 'uszkodzony plik'
  };

  const domyslnyKomunikat = pomylonyTyp
    ? `To wygląda na ${nazwyTypow[wykryto] || 'inny dokument'}, a w tym kroku potrzebny jest ${oczekiwano === 'cennik' ? 'cennik' : 'plik faktury'}.`
    : 'Nie rozpoznano zawartości pliku.';

  const wpisyDiagnostyki = diagnostyka && typeof diagnostyka === 'object'
    ? Object.entries(diagnostyka)
    : [];

  return (
    <div style={{
      backgroundColor: tlo, border: `1px solid ${ramka}`, borderRadius: '6px',
      padding: '12px', marginBottom: '12px'
    }}>
      <div style={{ fontSize: '12px', color: 'var(--text)', fontWeight: '600' }}>
        {pomylonyTyp ? '🔀' : '⛔'} {komunikat || domyslnyKomunikat}
      </div>

      {filename && (
        <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '4px', fontFamily: 'monospace' }}>
          {filename}
        </div>
      )}

      <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
        {pomylonyTyp && sugerowanyKrok && onUzyjWInnymKroku && (
          <button
            onClick={onUzyjWInnymKroku}
            style={{
              padding: '6px 12px', fontSize: '11px', borderRadius: '4px',
              border: '1px solid var(--primary)', backgroundColor: 'var(--primary)',
              color: '#fff', cursor: 'pointer', fontWeight: '600'
            }}
          >
            U{'ż'}yj tego pliku w Kroku {sugerowanyKrok} ({sugerowanyKrok === 1 ? 'cennik' : 'faktura'})
          </button>
        )}
        {/* Furtka dla uprawnionego: detektor moze sie pomylic na nietypowym
            formacie dostawcy, a bez tego przycisku falszywe rozpoznanie
            zatrzymywaloby przyjecie towaru do czasu poprawki kodu. */}
        {moznaWymusic && onWymus && (
          <button
            onClick={onWymus}
            style={{
              padding: '6px 12px', fontSize: '11px', borderRadius: '4px',
              border: '1px solid var(--warning)', backgroundColor: 'var(--warning)',
              color: '#fff', cursor: 'pointer', fontWeight: '600'
            }}
          >
            To jednak jest {oczekiwano === 'cennik' ? 'cennik' : 'faktura'} {'—'} przetw{'ó'}rz mimo wszystko
          </button>
        )}
        {onWybierzInny && (
          <button
            onClick={onWybierzInny}
            style={{
              padding: '6px 12px', fontSize: '11px', borderRadius: '4px',
              border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)',
              color: 'var(--text-secondary)', cursor: 'pointer'
            }}
          >
            Wybierz inny plik
          </button>
        )}
      </div>

      {wpisyDiagnostyki.length > 0 && (
        <div style={{ marginTop: '8px' }}>
          <button
            onClick={() => setPokazSzczegoly(v => !v)}
            style={{
              padding: '4px 10px', fontSize: '10px', borderRadius: '4px',
              border: '1px solid var(--border)', backgroundColor: 'transparent',
              color: 'var(--text-muted)', cursor: 'pointer'
            }}
          >
            {pokazSzczegoly ? 'Ukryj szczegóły' : 'Szczegóły'}
          </button>
          {pokazSzczegoly && (
            <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '6px', lineHeight: '1.5' }}>
              {wpisyDiagnostyki.map(([klucz, wartosc]) => (
                <div key={klucz}>
                  <span style={{ fontWeight: '600' }}>{klucz}:</span>{' '}
                  {typeof wartosc === 'object' ? JSON.stringify(wartosc) : String(wartosc)}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WrongFileNotice;
